import React, { useEffect, useState } from 'react';
import SelectFieldQuery from '../fields/select/SelectFieldQuery';
import { useGetLookupsQuery } from '../../../store/RTKQuery/lookups/getLookups';
import { ISelectItem } from '../../../models/select-item';
import { convertLookupsToSelectItem } from '../../../utils/convertToSelectItem';
import { useSelector } from 'react-redux';
import { selectUtility } from '../../../store/reducers/utilitySlice';

interface IProps {
    name: string;
    className?: string;
    label?: string;
    placeholder?: string;
}

const CurrencyTypeSelect: React.FC<IProps> = (props) => {
    const { name, className, label, placeholder } = props;
    const { lang } = useSelector(selectUtility);
    const { data, isSuccess } = useGetLookupsQuery({
        lang: lang,
    });
    const [options, setOptions] = useState<ISelectItem[]>([]);
    useEffect(() => {
        if (isSuccess && data) {
            setOptions(
                convertLookupsToSelectItem(data.data.currencies, 'code'),
            );
        }
    }, [isSuccess]);
    return (
        <SelectFieldQuery
            name={name}
            label={label}
            placeholder={placeholder}
            className={className}
            data={options}
        />
    );
};
export default CurrencyTypeSelect;
